const isPrimepay = () => window.partner === "primepay" || window.location.pathname.slice(0, 9) === "/primepay";

export default isPrimepay;

export const isPrimepayContinueSync = () =>
  window.location.pathname === "/primepay/router/small-group/select-plan" || window.location.pathname === "/primepay/connect";
